"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var base_1 = require("./base");
var BlueGatewayClient = /** @class */ (function (_super) {
    __extends(BlueGatewayClient, _super);
    function BlueGatewayClient(debug, gatewayConfig, interceptor) {
        if (debug === void 0) { debug = true; }
        var _this = this;
        var defaultReqInterceptor = function (req) {
            if (interceptor && interceptor.request) {
                return interceptor.request(req);
            }
            return req;
        };
        var defaultRespInterceptor = function (resp) {
            var payload = {};
            // 过滤掉一层data
            if (resp.data.retCode === _this.successCode) {
                resp.data.data ? (payload = resp.data.data) : (payload = {});
                resp.data = payload;
            }
            if (interceptor && interceptor.response) {
                return interceptor.response(resp);
            }
            return resp;
        };
        _this = _super.call(this, debug, defaultReqInterceptor, defaultRespInterceptor) || this;
        _this.gatewayUrl = gatewayConfig.gatewayUrl;
        _this.edition = gatewayConfig.edition;
        _this.goods = gatewayConfig.goods;
        _this.terrace = gatewayConfig.terrace;
        _this.token = '';
        return _this;
    }
    BlueGatewayClient.prototype.setToken = function (token) {
        this.token = token;
    };
    BlueGatewayClient.prototype.removeToken = function () {
        this.token = '';
    };
    /**
     * 请求前的签名处理
     * @param url 请求地址
     * @param reqData 请求body的内容
     * @param method 请求方法
     * @param token 身份token
     * @param params 请求地址后面追加的查询参数（问号后面的key value）
     * @param header 请求头部
     */
    BlueGatewayClient.prototype.prepareRequest = function (url, reqData, method, token, params, header) {
        if (token === void 0) { token = ''; }
        /**
         * 如果是get 和 put，用url params生成Sign，如果是post则用reqData生成Sign
         * @param httpMethod Http 请求方法
         */
        var signWithReqData = function (httpMethod) {
            if (httpMethod === 'get' ||
                httpMethod === 'put' ||
                httpMethod === 'delete') {
                return false;
            }
            return true;
        };
        if (!header) {
            header = {
                Edition: this.edition,
                Goods: this.goods,
                Terrace: this.terrace
            };
        }
        // 生成secretKey
        var secretKey = this.secret.getGatewayAPISecretKey(header.Goods, header.Terrace, header.Edition, token);
        header.Pencil = this.secret.getSign(signWithReqData(method) ? reqData : params, secretKey);
        header.secret = secretKey;
        header.Right = token;
        return this.fetch(url, header, method, reqData, true, params);
    };
    ////////////////////////// API //////////////////////////
    /**
     * 微信js sdk 参数
     * @param url
     */
    BlueGatewayClient.prototype.jsapiTicket = function (url) {
        return this.blueClientGetRequest(this.gatewayUrl + "api/oauth/getSignatureV2", { url: url });
    };
    /**
     * 获取code的Url
     * @param url
     */
    BlueGatewayClient.prototype.getCodeUrl = function (url) {
        return this.blueClientGetRequest(this.gatewayUrl + "api/wechat/getCodeUrl", { url: url }, '');
    };
    /**
     * 获取openId
     * @param code
     */
    BlueGatewayClient.prototype.getOpenId = function (code) {
        return this.blueClientGetRequest(this.gatewayUrl + "api/wechat/getOpenId", {
            code: code
        });
    };
    /**
     * 用户登录接口
     * @param phone 手机号码
     * @param password 验证码
     * @param source 来源，0-微信公众号，2-IOS，3-Android，4-微信小程序
     * @param openId 微信公众号ID
     */
    BlueGatewayClient.prototype.login = function (phone, password, source, openId) {
        if (openId === void 0) { openId = ''; }
        return this.blueClientGetRequest(this.gatewayUrl + "api/owner/user/login", {
            phone: phone,
            password: password,
            source: source,
            openId: openId
        });
    };
    /**
     * 用户登录接口
     * @param ownerId 业主ID
     * @param openId 微信公众号ID
     */
    BlueGatewayClient.prototype.updateOpenId = function (ownerId, openId) {
        if (openId === void 0) { openId = ''; }
        return this.prepareRequest(this.gatewayUrl + "api/Owner/openId/" + ownerId, { openId: openId }, 'put', '', { openId: openId });
    };
    /**
     * 用户登录接口
     * @param ownerId 业主ID
     * @param openId 微信公众号ID
     */
    BlueGatewayClient.prototype.loginOut = function (ownerId, openId) {
        if (openId === void 0) { openId = ''; }
        return this.prepareRequest(this.gatewayUrl + "api/Owner/wechat/logout", { openId: openId, ownerId: ownerId }, 'POST');
    };
    /**
     * 业主信息
     * @param id
     */
    BlueGatewayClient.prototype.ownerDetail = function (id) {
        return this.prepareRequest(this.gatewayUrl + "api/Owner/" + id, {}, 'get', '', {});
    };
    /**
     * 获取业主报表
     * @param roomId 查询房间ID
     */
    BlueGatewayClient.prototype.ownerReportHome = function (roomId, ownerId) {
        return this.prepareRequest(this.gatewayUrl + "api/Report/owner/" + ownerId, {}, 'get', '', { roomId: roomId });
    };
    /**
     * 查询业主的合同接口
     * @param ownerId 业主Id
     * @param signed 签约状态
     */
    BlueGatewayClient.prototype.findContractForWechat = function (ownerId, signed) {
        return this.prepareRequest(this.gatewayUrl + "api/ContractOnline/findContractForWechat", {}, 'get', '', {
            ownerId: ownerId,
            signed: signed
        });
    };
    /**
     * 线上合同创建
     * @param ownerId 业主ID
     * @param createName 创建人
     * @param foreignIds 房间测评ID集合
     */
    BlueGatewayClient.prototype.ContractOnlineForWechat = function (ownerId, createName, foreignIds, signCity, signDate, token) {
        return this.prepareRequest(this.gatewayUrl + "api/ContractOnlineForWechat", {
            ownerId: ownerId,
            createName: createName,
            foreignIds: foreignIds,
            signCity: signCity,
            signDate: signDate
        }, 'post', token, {});
    };
    /**
     * 保存房间测评信息
     * @param roomStructure 房屋结构:1标准平层，2复式结构，3别墅，4四合院
     * @param isElevator 是否有电梯：1是，0否
     * @param studyNum 书房数量
     * @param kitchenNum 厨房数量
     * @param city 市
     * @param createName 创建人
     * @param roomName 房间号
     * @param hallNum 大厅数量
     * @param floor 所在楼层
     * @param yardNum 院子数量
     * @param softCondition 软装条件：1无家具，2需补充/调整家具，3酒店客房标准，4自住家具标准
     * @param limitType 出入限制:1门禁卡/钥匙，2前台/门卫登记，3出入无限制
     * @param area 面积，单位㎡
     * @param status 默认：1。测评状态：1未签约，2已签约，3业主删除
     * @param address 详细地址
     * @param salesmanName 业务员名称
     * @param busDistanceType 公交车站距离类型：1：0~500m，2：500~1000m，3：1000m以上
     * @param province 省
     * @param salesmanPhone 业务员联系方式
     * @param updateName 修改人
     * @param buildYear 建成年份
     * @param isTraffic 1km内是否有公共交通站点，1是，0否
     * @param ownerId 蓝主人ID
     * @param toiletNum 卫生间数量
     * @param buildingType 楼宇性质,1商住楼，2民宅楼，3办公楼，4综合楼，5其他
     * @param appearance 公共外观:1崭新，2较新，3一般，4老旧
     * @param updateDate 修改时间
     * @param district 区
     * @param subwayDistanceType 地铁站距离类型：1：0~500m，2：500~1000m，3：1000m以上
     * @param houseType 房源类型：1租赁房间，2自有房间
     * @param contractOnlineId 不要传。线上合同ID
     * @param buildingName 楼宇名称
     * @param balconyNum 阳台数量
     * @param bedroomNum 卧室数量
     * @param bedNum 床铺数量
     * @param hardCondition 硬装条件：1毛坯房，2需装修，3简装，4精装，5豪装
     */
    BlueGatewayClient.prototype.RoomEvaluation = function (params) {
        return this.prepareRequest(this.gatewayUrl + "api/RoomEvaluation", __assign({}, params), 'post');
    };
    /**
     * 根据合同ID查询房间测评接口
     * @param contractOnlineId 合同ID
     */
    BlueGatewayClient.prototype.findByContractOnlineId = function (contractOnlineId) {
        return this.prepareRequest(this.gatewayUrl + "api/RoomEvaluation/findByContractOnlineId", {}, 'get', '', {
            contractOnlineId: contractOnlineId
        });
    };
    /**
     * 线上合同修改接口-微信端
     * @param modifyContractOnlineId 修改线上合同
     */
    BlueGatewayClient.prototype.modifyContractOnlineId = function (modifyContractOnlineId) {
        return this.prepareRequest(this.gatewayUrl + "api/ContractOnline/editContractOnlineForWechat", {}, 'put', '', __assign({}, modifyContractOnlineId));
    };
    /**
     * 查询评测历史（分页）
     * @param ownerId 蓝主人ID
     * @param size 每页记录数
     * @param page 从1开始
     */
    BlueGatewayClient.prototype.roomEvaluationHistory = function (ownerId, size, page) {
        return this.prepareRequest(this.gatewayUrl + "api/RoomEvaluation/history", {}, 'get', '', {
            ownerId: ownerId,
            size: size,
            page: page
        });
    };
    /**
     * 删除评测历史
     * @param roomEvaluationId 房间测评ID
     */
    BlueGatewayClient.prototype.deleteRoomEvaluationHistory = function (roomEvaluationId) {
        return this.prepareRequest(this.gatewayUrl + "api/RoomEvaluation/" + roomEvaluationId, {}, 'delete', '', {});
    };
    /**
     * 查询蓝主人历史楼宇
     * @param ownerId 蓝主人ID
     */
    BlueGatewayClient.prototype.buildingHistory = function (ownerId) {
        return this.prepareRequest(this.gatewayUrl + "api/RoomEvaluation/buildingHistory", {}, 'get', '', {
            ownerId: ownerId
        });
    };
    /**
     * 查询所有广告
     * @param terminal 终端(0所有，1微信，2IOS，3Android，4微信蓝主人，5Xbed官网)
     */
    BlueGatewayClient.prototype.findAllAdvert = function (terminal) {
        return this.blueClientPostRequest(this.gatewayUrl + "api/oms/appbase/advert/findAllAdvert", { terminal: terminal }, 'post');
    };
    /**
     * 业主日结账单列表
     * @param page 开始行
     * @param rows 每页显示数量
     * @param startDate 查询开始时间
     * @param ownerId 业主Id
     * @param endDate 查询截止时间
     */
    BlueGatewayClient.prototype.findOwnerReportByDay = function (page, rows, startDate, ownerId, endDate
        // token: string
    ) {
        return this.prepareRequest(this.gatewayUrl + "api/OwnerIncome/findOwnerReportByDay", {}, 'get', '', {
            page: page,
            rows: rows,
            startDate: startDate,
            ownerId: ownerId,
            endDate: endDate
        });
    };
    /**
     * 业主日结账单详情
     * @param ownerId 业主Id
     * @param curDate 查询日期
     */
    BlueGatewayClient.prototype.findOwnerDayReport = function (ownerId, curDate, roomIdList) {
        return this.prepareRequest(this.gatewayUrl + "api/OwnerIncome/findOwnerDayReport", {}, 'get', '', {
            ownerId: ownerId,
            curDate: curDate,
            roomIdList: roomIdList
        });
    };
    /**
     * 业主所属房间日结账单列表
     * @param ownerId 业主Id
     * @param curDate 查询日期
     * @param page 开始行
     * @param rows 每页显示条数
     */
    BlueGatewayClient.prototype.findOwnerRoomDayReport = function (ownerId, curDate, page, rows) {
        return this.prepareRequest(this.gatewayUrl + "api/OwnerIncome/findOwnerRoomDayReport", {}, 'get', '', {
            ownerId: ownerId,
            curDate: curDate,
            page: page,
            rows: rows
        });
    };
    /**
     * 业主月结账单列表
     * @param rows 每页显示条数
     * @param page 开始行
     * @param ownerId 业主Id
     */
    BlueGatewayClient.prototype.findOwnerReportByMonth = function (rows, page, ownerId) {
        return this.prepareRequest(this.gatewayUrl + "api/OwnerIncome/findOwnerReportByMonth", {}, 'get', '', {
            rows: rows,
            page: page,
            ownerId: ownerId
        });
    };
    /**
     * 业主月结账单详情
     * @param ownerId 业主Id
     * @param yearMonth 查询月份
     */
    BlueGatewayClient.prototype.findOwnerMonthReport = function (ownerId, curYearMonth, roomIdList) {
        return this.prepareRequest(this.gatewayUrl + "api/OwnerIncome/findOwnerMonthReport", {}, 'get', '', {
            ownerId: ownerId,
            curYearMonth: curYearMonth,
            roomIdList: roomIdList
        });
    };
    /**
     * 房间月结账单详情
     * @param ownerId 业主Id
     * @param xbedRoomId xbed房间Id
     * @param curYearMonth 查询月份
     */
    BlueGatewayClient.prototype.findRoomMonthReport = function (ownerId, xbedRoomId, curYearMonth) {
        return this.prepareRequest(this.gatewayUrl + "api/OwnerIncome/findRoomMonthReport", {}, 'get', '', {
            ownerId: ownerId,
            xbedRoomId: xbedRoomId,
            curYearMonth: curYearMonth
        });
    };
    /**
     * 房间月结账单明细
     * @param ownerId 业主Id
     * @param rows 每页显示条数
     * @param yearMonth 查询月份
     * @param page 开始行
     * @param roomId xbed房间Id
     */
    BlueGatewayClient.prototype.findRoomMonthReportDetail = function (ownerId, rows, curYearMonth, page, roomId) {
        return this.prepareRequest(this.gatewayUrl + "api/OwnerIncome/findRoomMonthReportDetail", {}, 'get', '', {
            ownerId: ownerId,
            rows: rows,
            curYearMonth: curYearMonth,
            page: page,
            roomId: roomId
        });
    };
    /**
     * 房间月结账单列表
     * @param page 开始行
     * @param rows 每页显示条数
     * @param curYearMonth 月份
     * @param roomIdList 房间Id
     * @param ownerId 业主Id
     */
    BlueGatewayClient.prototype.findRoomReportByMonth = function (page, rows, curYearMonth, roomIdList, ownerId) {
        return this.prepareRequest(this.gatewayUrl + "api/OwnerIncome/findRoomReportByMonth", {}, 'get', '', {
            page: page,
            rows: rows,
            curYearMonth: curYearMonth,
            roomIdList: roomIdList,
            ownerId: ownerId
        });
    };
    /**
     * 根据业主ID获取活动列表+未参加的信息
     */
    BlueGatewayClient.prototype.activityList = function (ownerId) {
        return this.prepareRequest(this.gatewayUrl + "api/Marketing/list/" + ownerId, {}, 'get', '', {});
    };
    /**
     * 更新活动/卡券的读状态
     * @param ownerId  用户id
     * @param activityId  活动id
     * @param couponCardId  卡券id
     */
    BlueGatewayClient.prototype.updateReadStatus = function (ownerId, activityId, couponCardId) {
        return this.prepareRequest(this.gatewayUrl + "api/Marketing/updateReadStatus", {}, 'put', '', { ownerId: ownerId, activityId: activityId, couponCardId: couponCardId });
    };
    /**
     * 通过活动或者卡券的ID+蓝主人ID查询已参加、已拒绝的列表
     * @param couponCardId 卡券ID
     * @param ownerId 蓝主人ID
     * @param activityId 活动ID
     */
    BlueGatewayClient.prototype.getMarketingById = function (couponCardId, ownerId, activityId) {
        return this.prepareRequest(this.gatewayUrl + "api/Marketing/getMarketingById", {}, 'get', '', {
            couponCardId: couponCardId,
            ownerId: ownerId,
            activityId: activityId
        });
    };
    /**
     * 增加不参加活动/卡券的房间
     * @param roomIds 多个房间的ID房间，多个房间逗号分隔
     * @param activityId 活动ID
     * @param ownerId 蓝主人ID
     * @param couponCardId 卡券ID
     */
    BlueGatewayClient.prototype.moreExcludeRoom = function (roomIds, activityId, ownerId, couponCardId) {
        return this.prepareRequest(this.gatewayUrl + "api/MarketingExcludeRoom/more", {
            roomIds: roomIds,
            activityId: activityId,
            ownerId: ownerId,
            couponCardId: couponCardId
        }, 'post');
    };
    /**
     * 增加参加活动/卡券的房间
     * @param ownerId 蓝主人ID
     * @param activityId 活动ID
     * @param roomIds 房间，多个房间逗号分隔
     * @param couponCardId 卡券ID
     */
    BlueGatewayClient.prototype.moreIncludeRoom = function (ownerId, activityId, roomIds, couponCardId) {
        return this.prepareRequest(this.gatewayUrl + "api/MarketingIncludeRoom/more", {
            ownerId: ownerId,
            activityId: activityId,
            roomIds: roomIds,
            couponCardId: couponCardId
        }, 'post');
    };
    /**
     * 取风格列表
     */
    BlueGatewayClient.prototype.listMore = function () {
        return this.prepareRequest(this.gatewayUrl + "api/RoomTheme/listMore", {}, 'get', '', {});
    };
    /**
     * 取主题下的模板
     */
    BlueGatewayClient.prototype.getThemeModule = function (themeId) {
        return this.prepareRequest(this.gatewayUrl + "api/RoomTheme/simple/" + themeId, {}, 'get', '', {});
    };
    /**
     * 取业主的房间
     */
    BlueGatewayClient.prototype.getOwnerRoom = function (ownerId) {
        return this.prepareRequest(this.gatewayUrl + "api/Room/owner/" + ownerId, {}, 'get', '', {});
    };
    /**
     * 根据标签搜索业主房间
     * @param ownerId 业主ID
     * @param tagCnameWay 搜索关键字
     */
    BlueGatewayClient.prototype.getOwnerRoomTagSearch = function (ownerId, tagCnameWay) {
        return this.prepareRequest(this.gatewayUrl + "api/Room/owner/tag/search", {}, 'get', '', { ownerId: ownerId, tagCnameWay: tagCnameWay });
    };
    /**
     * 获取业主房间的标签集合
     * @param ownerId 业主ID
     * @param tagCnameWay 标签关键字
     */
    BlueGatewayClient.prototype.getOwnerRoomTagList = function (ownerId, tagCname) {
        return this.prepareRequest(this.gatewayUrl + "api/Room/owner/tag/list", {}, 'get', '', { ownerId: ownerId, tagCname: tagCname });
    };
    /**
     * 房间详情
     */
    BlueGatewayClient.prototype.getRoomInfo = function (ownerId) {
        return this.prepareRequest(this.gatewayUrl + "api/Room/more/" + ownerId, {}, 'get', '', {});
    };
    /**
     * 房间详请获取停用单列表
     * @param rows 页大小
     * @param page 当前页
     * @param roomId 蓝主人房间Id
     */
    BlueGatewayClient.prototype.findStopListByRoomId = function (rows, page, roomId) {
        return this.prepareRequest(this.gatewayUrl + "api/Room/findStopListByRoomId", {}, 'get', '', {
            rows: rows,
            page: page,
            roomId: roomId
        });
    };
    /**
     * 查看入住单详情（业主）
     * @param checkinId 入住单Id
     */
    BlueGatewayClient.prototype.checkinOrderInfo = function (checkinId, ownerId) {
        return this.prepareRequest(this.gatewayUrl + "api/order/owner/checkinOrderInfo", {}, 'get', '', {
            checkinId: checkinId,
            ownerId: ownerId
        });
    };
    /**
     * 查询业主预订单列表
     * @param page 页码
     * @param type 类型
     * @param ownerId 业主Id(蓝主人端传递)
     * @param size 页大小
     */
    BlueGatewayClient.prototype.ownerOrderList = function (param) {
        return this.prepareRequest(this.gatewayUrl + "api/order/ownerOrderList", {}, 'get', '', param);
    };
    /**
     * 查询订单列表（业主）
     * @param type 类型
     * @param size 页大小
     * @param ownerId 业主Id(蓝主人端传递)
     * @param page 页码
     */
    BlueGatewayClient.prototype.orderList = function (param) {
        return this.prepareRequest(this.gatewayUrl + "api/order/orderList", {}, 'get', '', param);
    };
    /**
     * 根据orderNo取消申请业主自用单
     * @param orderNo 自用单orderNo
     */
    BlueGatewayClient.prototype.cancleByOrderNo = function (orderNo) {
        return this.prepareRequest(this.gatewayUrl + "api/auth/ownerOrder/cancleByOrderNo", {}, 'put', '', {
            orderNo: orderNo
        });
    };
    /**
     * 获取开门密码
     * @param checkinId 入住单Id
     */
    BlueGatewayClient.prototype.ownerSelfCheckin = function (checkinId) {
        return this.prepareRequest(this.gatewayUrl + "api/auth/ownerOrder/checkin", {}, 'put', '', {
            checkinId: checkinId
        });
    };
    /**
     * 结束自用单
     * @param checkinId 入住单Id
     * @param roomId 房间Id
     */
    BlueGatewayClient.prototype.ownerSelfCheckout = function (checkinId, roomId) {
        return this.prepareRequest(this.gatewayUrl + "api/auth/ownerOrder/checkout", {}, 'put', '', {
            checkinId: checkinId,
            roomId: roomId
        });
    };
    /**
     * 业主自用单详情
     * @param orderNo 订单号
     * @param checkinId 入住单Id
     */
    BlueGatewayClient.prototype.ownerSelfOrderInfo = function (orderNo, checkinId) {
        return this.prepareRequest(this.gatewayUrl + "api/auth/ownerOrder/checkinOrderInfo", {}, 'get', '', {
            orderNo: orderNo,
            checkinId: checkinId
        });
    };
    /**
     * 查询业主自用单列表
     * @param phone 手机号码
     * @param type 类型
     * @param size 页大小
     * @param page 页码
     */
    BlueGatewayClient.prototype.ownerSelfOrderList = function (param, token) {
        return this.prepareRequest(this.gatewayUrl + "api/auth/ownerOrder/ownerOrderList", {}, 'get', token, param);
    };
    /**
     * 生成业主订单
     * @param cardCode 使用卡券code(非必传参数)
     * @param name 用户下单时填写的称呼
     * @param roomTypeId 打包房型id
     * @param commandName 口令姓名
     * @param rentType 租房类型
     * @param arrivalTime 预计到达时间。非必传
     * @param commandPhone 口令手机
     * @param activityId 指定执行活动id(如果不想选择活动就传递-1)
     * @param beginDate 订单开始时间
     * @param roomId 多个房间数组或逗号隔开
     * @param xdollar Xdollar的数量(非必传参数)
     * @param isPackage 是否为打包房型下单(1:是0:否)
     * @param command 口令
     * @param endDate 订单结束时间
     */
    BlueGatewayClient.prototype.createOwnerOder = function (param, token) {
        return this.prepareRequest(this.gatewayUrl + "api/auth/order/createOrder/v2", param, 'post', token);
    };
    /**
     * 获取免审次数
     * @param roomId 房间Id
     */
    BlueGatewayClient.prototype.getRestrictionTimes = function (roomId, token) {
        return this.prepareRequest(this.gatewayUrl + "api/auth/ownerOrder/getRestrictionTimes", {}, 'get', token, {
            roomId: roomId
        });
    };
    /**
     * 获取短信验证码
     * @param phone 手机号码
     * @param isText 是否是文字。true-文字
     */
    BlueGatewayClient.prototype.getVerificationCode = function (phone, isText) {
        return this.prepareRequest(this.gatewayUrl + "api/owner/getVerificationCode", {
            phone: phone,
            isText: isText
        }, 'post');
    };
    /**
     * 房间测评图片批量上传接口(删除旧的，保存新的)
     * @param ownerImgInfoArrayStr 数组名称    只传这个数组，其他的都是数组内每个对象的属性
     * @param foreignId 对应的测评id或者合同id
     * @param createName 创建人
     * @param mediaId 微信图片编号
     * @param tableType 1表示测评，2表示合同
     * @param imgType 图片类型
     * @param imgUrl 图片url路径
     */
    BlueGatewayClient.prototype.batAddEvaluationImg = function (ownerImgInfoArrayStr) {
        return this.prepareRequest(this.gatewayUrl + "api/batAddEvaluationImg", {
            ownerImgInfoArrayStr: ownerImgInfoArrayStr
        }, 'post');
    };
    /**
     * 金融服务 新增
     * @param province 省
     * @param name 姓名
     * @param district 区
     * @param address 街道地址
     * @param city 市
     * @param mobile 手机
     * @param ltype 类型
     */
    BlueGatewayClient.prototype.Lender = function (params) {
        return this.prepareRequest(this.gatewayUrl + "api/Lender", __assign({}, params), 'post');
    };
    /**
     * 金融服务 新增平安投保人和房间
     * @param certificateNo 证件号码
     * @param certificateType 证件类型固定为01
     * @param mobileTelephone 手机号码
     * @param name 投保人姓名
     * @param ownerId 业主id
     * @param roomIdArray 房间id列表，逗号分割
     */
    BlueGatewayClient.prototype.addPingAn = function (certificateNo, certificateType, mobileTelephone, name, ownerId, roomIdArray) {
        return this.prepareRequest(this.gatewayUrl + "api/Insurance/pingan", {
            certificateNo: certificateNo,
            certificateType: certificateType,
            mobileTelephone: mobileTelephone,
            name: name,
            ownerId: ownerId,
            roomIdArray: roomIdArray
        }, 'post');
    };
    /**
     * 修改业主
     * @param bankAccount 银行账号
     * @param bankUser 开户名
     * @param type 账户性质:1个人，2企业
     * @param email 邮箱
     * @param address 详细地址
     * @param gender 性别
     * @param id 业主id
     * @param province 省份
     * @param mobile 手机号码
     * @param developerId 开发者Id（下拉列表取id传进来）
     * @param clubId 俱乐部Id
     * @param city 城市
     * @param isMaker 是否创客：1是，0否（必传）
     * @param district 区
     * @param bankName 开户银行名称
     * @param name 姓名
     */
    BlueGatewayClient.prototype.Owner = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/Owner", {}, 'put', token, __assign({}, params));
    };
    /**
     * 图片新增接口
     * @param foreignId 对应的测评id或者合同id
     * @param imgType 图片类型：1卧室图，2房屋其它区域图，3房产证，4租赁合同，5本人签名图，6甲方身份证正面，7甲方身份证反面，8转账截图
     * @param imgUrl 图片url路径
     * @param imgCode base64编码
     * @param tableType 1表示测评，2表示合同
     * @param createName 创建人
     */
    BlueGatewayClient.prototype.OwnerImgInfo = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/OwnerImgInfo", __assign({}, params), 'post', token);
    };
    /**
     * 甲方身份证认证
     * @param cardBackMediaId	身份证背面	string
     * @param cardFrontMediaId	身份证正面	string
     * @param contractOnlineId	合同ID	number
     * @param createName	创建人	string
     */
    BlueGatewayClient.prototype.OwnerAuthImg = function (params) {
        return this.prepareRequest(this.gatewayUrl + "api/OwnerImgInfo/authentication", __assign({}, params), 'post');
    };
    /**
     * 图片查询接口
     * @param foreignIds 对应的测评id或者合同id
     * @param tableType 1表示测评，2表示合同
     */
    BlueGatewayClient.prototype.OwnerImgInfoQuery = function (foreignIds, tableType) {
        return this.prepareRequest(this.gatewayUrl + "api/OwnerImgInfo/query", {}, 'get', '', {
            foreignIds: foreignIds,
            tableType: tableType
        });
    };
    /**
     * 个人中心身份验证接口
     * @param cardFrontMediaId 身份证正面图
     * @param id 业主ID
     * @param businessLicenseMediaId 营业执照图
     * @param cardBackMediaId 身份证背面图
     */
    BlueGatewayClient.prototype.authentication = function (params) {
        return this.prepareRequest(this.gatewayUrl + "api/Owner/authentication", __assign({}, params), 'post');
    };
    /**
     * 查询合同证件图
     * @param contractOnlineId 线上合同ID
     */
    BlueGatewayClient.prototype.getCertiflcatesImg = function (contractOnlineId) {
        return this.prepareRequest(this.gatewayUrl + "api/OwnerImgInfo/findCertificatesImg", {}, 'get', '', { contractOnlineId: contractOnlineId });
    };
    /**
     * 查询线上合同接口
     * @param contractOnlineId 线上合同ID
     */
    BlueGatewayClient.prototype.getContractOnline = function (contractOnlineId) {
        return this.prepareRequest(this.gatewayUrl + "api/ContractOnline/" + contractOnlineId, {}, 'get', '', {});
    };
    /**
     * 线上合同状态修改接口
     * @param contractOnlineId 线上合同ID
     * @param status 合同状态：1线下协商，2待确认合同，3待上传证件，4证件审核中，5待支付费用，6待确认转账，7签约成功
     * @param updateName 修改人
     */
    BlueGatewayClient.prototype.editContractStatus = function (contractOnlineId, status, updateName) {
        return this.prepareRequest(this.gatewayUrl + "api/ContractOnline/editContractStatus", {}, 'put', '', { contractOnlineId: contractOnlineId, status: status, updateName: updateName });
    };
    /**
     * 查询房价日历
     * @param roomId 房间ID
     * @param beginDateTime 开始时间 yyyy-MM-dd HH:mm:ss
     * @param endDateTime 结束时间 yyyy-MM-dd HH:mm:ss
     */
    BlueGatewayClient.prototype.getCalendar = function (roomId, beginDateTime, endDateTime) {
        return this.prepareRequest(this.gatewayUrl + "api/room/getRemoteRoomsStatus", {}, 'get', '', { roomId: roomId, beginDateTime: beginDateTime, endDateTime: endDateTime });
    };
    /**
     * 获取七牛云上传token
     * @param source  来源
     * @param isPrivate 0 公有库 1 私有库
     * @param token
     */
    BlueGatewayClient.prototype.getUploadToken = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/material/getQiNiuToken", {}, 'get', token, __assign({}, params));
    };
    /**
     * 七牛私有图片转换成可访问的地址
     * @param imgUrl 七牛私有地址
     * @param token
     */
    BlueGatewayClient.prototype.queryQiniuPrivateImageUrl = function (imgUrl, token) {
        return this.prepareRequest(this.gatewayUrl + "api/other/getPrivatePicUrl", { imgUrl: imgUrl }, 'post', token);
    };
    /**
     * 查询房间信息
     * @param ownerId 业主ID
     * @param type 查询类型 1城市 2门店房型 3房间
     * @param billType 账单类型	 day 日账单 month 月账单 选传
     * @param billDate 账单日期	 day 日 2018-01-01 月 2018-01 选传
     */
    BlueGatewayClient.prototype.searchRoom = function (params) {
        return this.prepareRequest(this.gatewayUrl + "api/OwnerIncome/selectRoomByType", {}, 'get', '', __assign({}, params));
    };
    /**
     * 中转接口。以前迁移后有问题需中转的接口
     * @param params 接口参数
     * @param url 请求的地址
     * @param method 请求的方法  默认post
     */
    BlueGatewayClient.prototype.redirectUrl = function (params, url, method) {
        if (method === void 0) { method = 'post'; }
        // const methods = method || 'post'
        if (method === 'get' || method === 'put') {
            return this.prepareRequest(this.gatewayUrl + "api/toOwner", {}, method, '', __assign({ url: url }, params));
        }
        else {
            return this.prepareRequest(this.gatewayUrl + "api/toOwner", __assign({ url: url }, params), method);
        }
    };
    /**
     * 查询省
     */
    BlueGatewayClient.prototype.getProvince = function () {
        return this.prepareRequest(this.gatewayUrl + "api/address/v2/provinces", {}, 'get', '', {});
    };
    /**
     * 查询市区
     */
    BlueGatewayClient.prototype.getCitys = function (id) {
        return this.prepareRequest(this.gatewayUrl + "api/address/v2/citys", {}, 'get', '', { id: id });
    };
    /**
     * 查询乡镇
     */
    BlueGatewayClient.prototype.getCountys = function (id) {
        return this.prepareRequest(this.gatewayUrl + "api/address/v2/countys", {}, 'get', '', { id: id });
    };
    /**
     * ruby中转接口。
     * @param params 接口参数
     * @param url 请求的地址
     * @param method 请求的方法  默认post
     */
    BlueGatewayClient.prototype.rubyRedirectUrl = function (params, url, method) {
        if (method === void 0) { method = 'post'; }
        // const methods = method || 'post'
        if (method === 'get' || method === 'put') {
            return this.prepareRequest(this.gatewayUrl + "api/oms/ruby/roomManagement", {}, method, '', __assign({ url: url }, params));
        }
        else {
            return this.prepareRequest(this.gatewayUrl + "api/oms/ruby/roomManagement", __assign({ url: url }, params), method);
        }
    };
    // /////////////////////////////////////////////////////////////////
    BlueGatewayClient.prototype.blueClientGetRequest = function (url, queryParams, token) {
        if (token === void 0) { token = ''; }
        return this.blueClientPrepareRequest(url, {}, token, 'get', queryParams);
    };
    BlueGatewayClient.prototype.blueClientPostRequest = function (url, data, token) {
        if (token === void 0) { token = ''; }
        return this.blueClientPrepareRequest(url, data, token, 'post');
    };
    /**
     * xbed client request
     *
     */
    BlueGatewayClient.prototype.blueClientPrepareRequest = function (url, reqData, token, method, params) {
        if (token === void 0) { token = ''; }
        if (method === void 0) { method = 'post'; }
        if (params === void 0) { params = {}; }
        return this.prepareRequest(url, reqData, method, token ? token : this.token, params, {
            Edition: this.edition,
            Goods: this.goods,
            Terrace: this.terrace
        });
    };
    return BlueGatewayClient;
}(base_1.BaseClient));
exports.BlueGatewayClient = BlueGatewayClient;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/clients/blue-gateway-client.js
// module id = 204
// module chunks = 44